module.exports = __webpack_public_path__ + "static/media/elix.ffaef907.svg";